"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchListIfNeeded = fetchListIfNeeded;

var _ = require("./..");

var _EsbApi = require("./../api/EsbApi");

var _EsbApi2 = _interopRequireDefault(_EsbApi);

var _PravniFormaApi = require("./../api/gen/subjekty/PravniFormaApi");

var _PravniFormaApi2 = _interopRequireDefault(_PravniFormaApi);

var _SharedActions = require("./../shared/SharedActions");

var SharedActions = _interopRequireWildcard(_SharedActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Akce pro číselník právních forem.
 */
function getList() {
    return _PravniFormaApi2.default.getPravniFormy(null, false);
    // return EsbApi.getPravniFormy()
    //     .then(data => ({rows: data, count: 0}));
}

function fetchListIfNeeded(area) {
    return function (dispatch, getState) {
        dispatch(SharedActions.initIfNeeded(area, _.list.SimpleListReducer));

        dispatch(_.list.SimpleListActions.fetchIfNeeded(area, null, function () {
            return getList();
        }));
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvYWN0aW9ucy9wcmF2bmlGb3JteS1hY3Rpb25zLmpzeCJdLCJuYW1lcyI6WyJmZXRjaExpc3RJZk5lZWRlZCIsIlNoYXJlZEFjdGlvbnMiLCJnZXRMaXN0IiwiUHJhdm5pRm9ybWFBcGkiLCJnZXRQcmF2bmlGb3JteSIsImFyZWEiLCJkaXNwYXRjaCIsImdldFN0YXRlIiwiaW5pdElmTmVlZGVkIiwibGlzdCIsIlNpbXBsZUxpc3RSZWR1Y2VyIiwiU2ltcGxlTGlzdEFjdGlvbnMiLCJmZXRjaElmTmVlZGVkIl0sIm1hcHBpbmdzIjoiOzs7OztRQWNnQkEsaUIsR0FBQUEsaUI7O0FBWGhCOztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7SUFBWUMsYTs7Ozs7O0FBTlo7OztBQVFBLFNBQVNDLE9BQVQsR0FBbUI7QUFDZixXQUFPQyx5QkFBZUMsY0FBZixDQUE4QixJQUE5QixFQUFvQyxLQUFwQyxDQUFQO0FBQ0E7QUFDQTtBQUNIOztBQUVNLFNBQVNKLGlCQUFULENBQTJCSyxJQUEzQixFQUFpQztBQUNwQyxXQUFPLFVBQUNDLFFBQUQsRUFBV0MsUUFBWCxFQUF3QjtBQUMzQkQsaUJBQVNMLGNBQWNPLFlBQWQsQ0FBMkJILElBQTNCLEVBQWlDSSxPQUFLQyxpQkFBdEMsQ0FBVDs7QUFFQUosaUJBQVNHLE9BQUtFLGlCQUFMLENBQXVCQyxhQUF2QixDQUFxQ1AsSUFBckMsRUFBMkMsSUFBM0MsRUFBaUQsWUFBTTtBQUM1RCxtQkFBT0gsU0FBUDtBQUNILFNBRlEsQ0FBVDtBQUdILEtBTkQ7QUFPSCIsImZpbGUiOiJwcmF2bmlGb3JteS1hY3Rpb25zLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBBa2NlIHBybyDEjcOtc2VsbsOtayBwcsOhdm7DrWNoIGZvcmVtLlxuICovXG5pbXBvcnQge2xpc3R9IGZyb20gJy4vLi4nXG5pbXBvcnQgRXNiQXBpIGZyb20gXCIuLy4uL2FwaS9Fc2JBcGlcIjtcbmltcG9ydCBQcmF2bmlGb3JtYUFwaSBmcm9tIFwiLi8uLi9hcGkvZ2VuL3N1Ympla3R5L1ByYXZuaUZvcm1hQXBpXCI7XG5pbXBvcnQgKiBhcyBTaGFyZWRBY3Rpb25zIGZyb20gXCIuLy4uL3NoYXJlZC9TaGFyZWRBY3Rpb25zXCI7XG5cbmZ1bmN0aW9uIGdldExpc3QoKSB7XG4gICAgcmV0dXJuIFByYXZuaUZvcm1hQXBpLmdldFByYXZuaUZvcm15KG51bGwsIGZhbHNlKTtcbiAgICAvLyByZXR1cm4gRXNiQXBpLmdldFByYXZuaUZvcm15KClcbiAgICAvLyAgICAgLnRoZW4oZGF0YSA9PiAoe3Jvd3M6IGRhdGEsIGNvdW50OiAwfSkpO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZmV0Y2hMaXN0SWZOZWVkZWQoYXJlYSkge1xuICAgIHJldHVybiAoZGlzcGF0Y2gsIGdldFN0YXRlKSA9PiB7XG4gICAgICAgIGRpc3BhdGNoKFNoYXJlZEFjdGlvbnMuaW5pdElmTmVlZGVkKGFyZWEsIGxpc3QuU2ltcGxlTGlzdFJlZHVjZXIpKTtcblxuICAgICAgICBkaXNwYXRjaChsaXN0LlNpbXBsZUxpc3RBY3Rpb25zLmZldGNoSWZOZWVkZWQoYXJlYSwgbnVsbCwgKCkgPT4ge1xuICAgICAgICAgICAgcmV0dXJuIGdldExpc3QoKVxuICAgICAgICB9KSk7XG4gICAgfVxufVxuIl19